import { StringService } from '../../services/string';

export const defaultMapper = (key: string, value: unknown): Record<string, string> => {
  const isObject = (val: unknown): val is object => typeof val === 'object' && val !== null;

  return {
    [StringService.snakeToKebab(key)]: isObject(value)
      ? JSON.stringify(value)
      : typeof value === 'string'
        ? value.replace(/"/g, '&quot;')
        : String(value),
  };
};
